import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineAngleDownBIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m12.7996 15.5501 5.6-5.7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-5 4.9-5-4.9c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7 0 .3.1.5.3.7l5.6 5.7c.5.4 1.1.4 1.6 0-.1 0-.1 0 0 0Z"/>
  </SvgIcon>
}

export default LineAngleDownBIcon
